/** 分类 Tab / 筛选「全部」固定文案，各语言不翻译 */
export const CATEGORY_ALL_LABEL = '全部'
export const FILTER_ALL_LABEL = CATEGORY_ALL_LABEL

export function isAllTabValue(value) {
  return value === '' || value === 'all' || value === null || value === undefined
}

export function isAllTabLabel(label) {
  if (label === null || label === undefined || label === '') return true
  const allText = CATEGORY_ALL_LABEL
  const normalized = String(label).trim()
  return normalized === allText || normalized === '全部' || normalized === 'All'
}

export function isAllTabItem(tab) {
  if (!tab || typeof tab !== 'object') return false
  return isAllTabValue(tab.value) && isAllTabLabel(tab.label)
}

/** 无二级数据或仅有「全部」时不展示二级分类 */
export function getVisibleSubCategoryTabs(tabs) {
  if (!Array.isArray(tabs) || tabs.length === 0) return []
  const hasRealSubItems = tabs.some(tab => !isAllTabItem(tab))
  return hasRealSubItems ? tabs : []
}

/** 存在二级项时在开头补「全部」 */
export function buildSubCategoryTabs(subItems, options = {}) {
  if (!Array.isArray(subItems) || subItems.length === 0) return []

  const {
    allLabel = CATEGORY_ALL_LABEL,
    allValue = ''
  } = options

  return [
    { label: allLabel, value: allValue },
    ...subItems.map(item => ({
      label: item.label ?? item.itemValue ?? item.itemCode ?? '',
      value: item.value ?? item.itemCode ?? ''
    }))
  ]
}

export function buildSubCategoryTabsFromDict(subTypes, options = {}) {
  if (!Array.isArray(subTypes) || subTypes.length === 0) return []

  const sorted = [...subTypes].sort((a, b) => (a.sortNum || 0) - (b.sortNum || 0))
  return buildSubCategoryTabs(
    sorted.map(item => ({
      label: item.itemValue || item.itemCode || '',
      value: item.itemCode || ''
    })),
    options
  )
}
